var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.displayConditionOk
    ? _c("div", { staticClass: "form-group row" }, [
        _c("label", { staticClass: "col-12 col-form-label text-left" }, [
          _vm._v(_vm._s(_vm.label))
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selected,
                  expression: "selected"
                }
              ],
              attrs: { type: "hidden", name: _vm.name, required: _vm.required },
              domProps: { value: _vm.selected },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.selected = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c("v-select", {
              key: "value",
              ref: "select",
              staticClass: "form-control p-0",
              attrs: {
                options: _vm.items,
                multiple: _vm.multiple,
                placeholder: _vm.placeholder,
                label: "text",
                disabled: !_vm.items || _vm.readonly,
                "on-change": _vm.onChange
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "option",
                    fn: function(option) {
                      return [_vm._t("option", null, { option: option })]
                    }
                  },
                  {
                    key: "selected-option",
                    fn: function(option) {
                      return [
                        _vm._t("selected-option", null, { option: option })
                      ]
                    }
                  }
                ],
                null,
                true
              ),
              model: {
                value: _vm.value,
                callback: function($$v) {
                  _vm.value = $$v
                },
                expression: "value"
              }
            })
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-468e18cd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-468e18cd","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./_wwwsrc/js/Workflow/Components/Input/SelectCustom.vue
// module id = 559
// module chunks = 0